module.exports = __webpack_public_path__ + "img/Edelstahl.5c6f8ada.jpg";